import { useEffect, useState } from "react";

export const useImage = (src) => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [hasStartedInitialFetch, setHasStartedInitialFetch] = useState(false);

  const handleError = (e) => {
    console.log(e);
    setHasError(e);
  };

  const handleLoad = () => {
    setHasLoaded(true);
    setHasError(false);
  };

  useEffect(() => {
    setHasStartedInitialFetch(true);
    setHasLoaded(false);
    setHasError(false);

    // Here's where the magic happens.
    const image = new Image();
    image.src = src;

    image.onerror = handleError;
    image.onload = handleLoad;

    return () => {
      image.onerror = () => {};
      image.onload = () => {};
    };
  }, [src]);

  return { hasLoaded, hasError, hasStartedInitialFetch };
};
